var getPreferenceState = function getPreferenceState(state) {
  return state.preferences;
};
/**
 * Selects Redux state for a single preference value
 * @param {object} state Redux state
 * @param {string} key Preference key to find
 */


var getPreferenceValue = function getPreferenceValue(state, key) {
  var preferenceState = getPreferenceState(state);
  return preferenceState[key];
};

export { getPreferenceState, getPreferenceValue };
